import React, { useEffect, useState } from 'react'
import Button1 from '../../../Button/Button1'

import classes from "./StatePicker.module.css"
import Button2 from '../../../Button/Button2'
import Button from '../../../Button/Button'
const StatePickerMassHolidayMode = ({ pinText, HandleOutputState, pinNumber, states }) => {

  const [activeButton, setActiveButton] = useState("ignore")
  console.log(activeButton)

  const Handler = (buttonText) => {
    HandleOutputState(pinNumber, buttonText);
    setActiveButton(buttonText);
  }

  return (
    <div className={classes.container}>
      <h3>{pinText}</h3>
      <div className={classes.buttonContainer}>
        <Button2 style={{backgroundColor: activeButton === "arm" ? "var(--Primary-Color)" : "#cdcdcd"}} onClick={() => Handler("arm")}>arm</Button2>
        <Button2 style={{backgroundColor: activeButton === "disarm" ? "var(--Primary-Color)" : "#cdcdcd"}} onClick={() => Handler("disarm")}>disarm</Button2>
        <Button2 style={{backgroundColor: activeButton === "ignore" ? "var(--Primary-Color)" : "#cdcdcd"}} onClick={() => Handler("ignore")}>ignore</Button2>
      </div>
    </div>
  );
}
//<Button2 style={{ minWidth: "160px", backgroundColor: inputRuleSelected.inputRuleText == "Match the state" && "var(--Primary-Color)", color: inputRuleSelected.inputRuleText == "Match the state" && "white", border: inputRuleSelected.inputRuleText == "Match the state" && "2px solid lightblue" }} onClick={() => HandleInputRuleOnClick({ inputRule: "0", inputRuleText: "Match the state" })}>Match the state</Button2>

export default StatePickerMassHolidayMode